import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
interface ProgramaDisciplina {
  id: string;
  designacao: string;
}
@Injectable({
  providedIn: 'root'
})
export class ProgramaDisciplinaService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all Programa Disciplina
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: ProgramaDisciplina[] }>(`${this.path}/getAllProgramaDisciplina`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      map(response => response)
    );
  }

  // Get Programa Disciplina by ID
  public show(id: string): Observable<ProgramaDisciplina> {
    return this.apiService.get<{ object: ProgramaDisciplina }>(`${this.path}/getProgramaDisciplinaById/${id}`).pipe(
      map(response => response.object as ProgramaDisciplina)
    );
  }

  // Create new Programa Disciplina
  public store(programaDisciplina: ProgramaDisciplina): Observable<ProgramaDisciplina> {
    return this.apiService
      .post<{ object: ProgramaDisciplina }>(`${this.path}/AddProgramaDisciplina`, programaDisciplina)
      .pipe(
        map((response) => response.object as ProgramaDisciplina)
      );
  }

  // Update existing Programa Disciplina
  public update(programaDisciplina: ProgramaDisciplina): Observable<ProgramaDisciplina> {
    return this.apiService
      .put<{ object: ProgramaDisciplina }>(`${this.path}/UpdateProgramaDisciplina`, programaDisciplina)
      .pipe(
        map((response) => response.object as ProgramaDisciplina)
      );
  }

  // Delete existing Programa Disciplina
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteProgramaDisciplinaById/${id}`);
  }
}
